// Сами документы — только на русском (пакет `legal`): ссылки на других языках
// ведут на русский текст.
export default {
  en: {
    title: 'A couple of formalities',
    subtitle: 'By law I need your consent before we can start',
    more: 'More',
    consent: {
      title: 'Personal data processing',
      description: 'What data we collect while you practise, why, who we share it with and how long we keep it.',
    },
    offer: {
      title: 'Public offer',
      description: 'Terms of use, subscription and auto-renewal, payment and refunds.',
    },
    doc_consent: 'Consent to personal data processing',
    doc_privacy: 'Personal data processing policy',
    doc_offer: 'Public offer',
  },
  ru: {
    title: 'Пара формальностей',
    subtitle: 'По закону мне нужно твоё согласие, чтобы мы могли начать',
    more: 'Подробнее',
    consent: {
      title: 'Обработка персональных данных',
      description: 'Какие данные мы собираем во время занятий, зачем, кому передаём и сколько храним.',
    },
    offer: {
      title: 'Публичная оферта',
      description: 'Условия пользования, подписка и автопродление, порядок оплаты и возврата.',
    },
    doc_consent: 'Согласие на обработку персональных данных',
    doc_privacy: 'Политика обработки персональных данных',
    doc_offer: 'Публичная оферта',
  },
  de: {
    title: 'Ein paar Formalitäten',
    subtitle: 'Laut Gesetz brauche ich deine Zustimmung, bevor wir anfangen können',
    more: 'Mehr',
    consent: {
      title: 'Verarbeitung personenbezogener Daten',
      description: 'Welche Daten wir beim Üben erheben, wozu, an wen wir sie weitergeben und wie lange wir sie speichern.',
    },
    offer: {
      title: 'Öffentliches Angebot',
      description: 'Nutzungsbedingungen, Abo und automatische Verlängerung, Zahlung und Erstattung.',
    },
    doc_consent: 'Einwilligung zur Datenverarbeitung',
    doc_privacy: 'Datenschutzrichtlinie',
    doc_offer: 'Öffentliches Angebot',
  },
  pt: {
    title: 'Umas formalidades',
    subtitle: 'Por lei, preciso do seu consentimento para podermos começar',
    more: 'Mais',
    consent: {
      title: 'Tratamento de dados pessoais',
      description: 'Quais dados coletamos durante a prática, por quê, com quem compartilhamos e por quanto tempo guardamos.',
    },
    offer: {
      title: 'Oferta pública',
      description: 'Termos de uso, assinatura e renovação automática, pagamento e reembolso.',
    },
    doc_consent: 'Consentimento para tratamento de dados pessoais',
    doc_privacy: 'Política de tratamento de dados pessoais',
    doc_offer: 'Oferta pública',
  },
  fr: {
    title: 'Quelques formalités',
    subtitle: 'La loi m’oblige à avoir ton accord avant que nous puissions commencer',
    more: 'Plus',
    consent: {
      title: 'Traitement des données personnelles',
      description: 'Quelles données nous collectons pendant la pratique, pourquoi, avec qui nous les partageons et combien de temps nous les gardons.',
    },
    offer: {
      title: 'Offre publique',
      description: 'Conditions d’utilisation, abonnement et renouvellement automatique, paiement et remboursement.',
    },
    doc_consent: 'Consentement au traitement des données personnelles',
    doc_privacy: 'Politique de traitement des données personnelles',
    doc_offer: 'Offre publique',
  },
  es: {
    title: 'Un par de formalidades',
    subtitle: 'Por ley necesito tu consentimiento para que podamos empezar',
    more: 'Más',
    consent: {
      title: 'Tratamiento de datos personales',
      description: 'Qué datos recopilamos durante la práctica, para qué, con quién los compartimos y cuánto tiempo los guardamos.',
    },
    offer: {
      title: 'Oferta pública',
      description: 'Condiciones de uso, suscripción y renovación automática, pago y reembolso.',
    },
    doc_consent: 'Consentimiento para el tratamiento de datos personales',
    doc_privacy: 'Política de tratamiento de datos personales',
    doc_offer: 'Oferta pública',
  },
};
